import {
    SET_NOTIFICATIONS,
    GET_NOTIFICATIONS,
    ACTION_LIST_NOTIFICATIONS,
    ACTION_SHOW_BADGE,
    GET_SHOW_BADGE,
    SET_SHOW_BADGE,
    SET_CHANGE_STATE_NOTIFICATION,
    ACTION_CHANGE_STATE_NOTIFICATION

} from "@/shared/components/notifications/store/types.js";

import config from "@/shared/components/notifications/config/notification_api.js";
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const NOTIFICATIONS_MODULE = {
    namespaced: true,
    state: {
        notifications: [],
        showBadge: false,
    },

    //sync
    mutations: {
        [SET_NOTIFICATIONS]: (state, payload) => state.notifications = payload,
        [SET_SHOW_BADGE]: (state, payload) => state.showBadge = payload,
        [SET_CHANGE_STATE_NOTIFICATION]: (state, index) => state.notifications[index]['estado'] = 'VISTA',

    },

    //async - repository remote | local
    actions: {
        [ACTION_LIST_NOTIFICATIONS]: ({ state, commit, dispatch }) => {
            return new Promise((resolve, reject) => {
                axios({
                        method: 'get',
                        url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")+'/notificaciones/usuario'}`,
                        headers: {
                            'idEmpresa': sessionStorage.getItem("idEmpresa"),
                            'idUsuario': sessionStorage.getItem("idUsuario")
                        },
                    })
                    .then(resp => {
                        const notification = resp.data;
                        dispatch(ACTION_SHOW_BADGE, state.notifications.lenght == notification.lenght);
                        commit(SET_NOTIFICATIONS, notification);
                        resolve()
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
        [ACTION_SHOW_BADGE]: ({ commit }, data) => {
            commit(SET_SHOW_BADGE, data);
        },
        [ACTION_CHANGE_STATE_NOTIFICATION]: ({ state, commit }, idNotificacion) => {
            return new Promise((resolve, reject) => {
                axios({
                        method: 'put',
                        url: `${config.baseUrl+_pathUri.generateUri()+sessionStorage.getItem("idGroup")+'/notificaciones/'+idNotificacion}`
                    })
                    .then(() => {
                        const index = state.notifications.findIndex((notification) => notification.idNotificacion == idNotificacion)
                        if (index !== -1) {
                            commit(SET_CHANGE_STATE_NOTIFICATION, index)
                        }
                        resolve()
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
        },
    },
    getters: {
        [GET_NOTIFICATIONS]: state => state.notifications,
        [GET_SHOW_BADGE]: state => state.showBadge,
    }
};